import styled from "styled-components";

import { Text } from "@ui/Atoms/Text";

export const Heading = styled(Text).attrs({
  as: "h2",
  $style: {
    default: "bold_40",
    smallTablet: "bold_64",
    smallDesktop: "bold_80",
  },
  $breakWord: true,
})`
  --statement-padding-v: ${props => props.theme.spacing.spacing_96};

  padding-top: var(--statement-padding-v);
  padding-bottom: var(--statement-padding-v);

  ${props => props.theme.breakpointsV2.smallTablet} {
    --statement-padding-v: ${props => props.theme.spacing.spacing_160};
  }

  ${props => props.theme.breakpointsV2.smallDesktop} {
    --statement-padding-v: 196px;
  }
`;
